"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SETTINGS = void 0;
const helpers_1 = require("../../client/helpers");
const settings_fragments_1 = require("./settings.fragments");
exports.GET_SETTINGS = `
  query GetSettings {
    settings {
      ...SettingsFragment
    }
  }
  ${settings_fragments_1.SETTINGS_FRAGMENT}
`;
//# sourceMappingURL=settings.queries.js.map